// Auto generated file, do not manually modify!
// com.hotpads.rentalgrowth.web.listing.handler.RentalGrowthListingWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetListingByAddressRequestDto, GetListingByAddressResponseDto } from '../..';

export const RentalGrowthListingWebApiHandler_getByAddress_Path = '/api/web/v1/listing/getByAddress';

export const RentalGrowthListingWebApiHandler_getByAddress = (
  postData: GetListingByAddressRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, GetListingByAddressRequestDto, GetListingByAddressResponseDto>(
    {
      endpoint: RentalGrowthListingWebApiHandler_getByAddress_Path,
      method: 'POST',
      contextPath: '/rental-growth-api',
      postData: postData,
    },
    client,
  );
};
